import request from '@/utils/request'
export function selectRechargeGoods(data) {
    return request({
        url: `api/serviceCenter/goods/selectRechargeGoods?type=${data}`,
        method: 'post',
        data,
    })
}
export function native(data) {
    return request({
        url: `api/serviceCenter/wx-pay/native`,
        method: 'post',
        data,
    })
}
export function queryOrder(data) {
    return request({
        url: `api/serviceCenter/wx-pay/queryOrder?orderNo=${data}`,
        method: 'post',
        data,
    })
}

